import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "image", "title"]

  open(event) {
    const button = event.currentTarget
    const imageUrl = button.dataset.imagePreviewUrl
    if (!imageUrl) return

    this.imageTarget.src = imageUrl
    this.imageTarget.alt = button.dataset.imagePreviewTitle || ""
    this.titleTarget.textContent = button.dataset.imagePreviewTitle || "Session image"
    this.dialogTarget.classList.remove("hidden")
    this.dialogTarget.classList.add("flex")
  }

  close() {
    this.dialogTarget.classList.add("hidden")
    this.dialogTarget.classList.remove("flex")
    this.imageTarget.removeAttribute("src")
  }

  closeFromBackdrop(event) {
    if (event.target === this.dialogTarget) this.close()
  }

  closeFromKeyboard(event) {
    if (event.key === "Escape") this.close()
  }
}
